import { Observatory } from '@apollo/space-kit/illustrations/Observatory';
import React from 'react';

export const NoSearchResults = () => {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <Observatory />
      <div className="flex flex-col items-center justify-center">
        <div className="pb-1 pt-2 text-center font-semibold">
          No Operations Found
        </div>
        <div>Try changing your search criteria to see more results</div>
      </div>
    </div>
  );
};
